import React from 'react';
import { Notification } from '../../../Components/Notification';
import { Text } from '../../../globalStyles';
import { AppView } from '../../../graphQL';

export const DuplicateEmailMessage = ({ appView }: { appView: AppView }) => {
  if (appView === AppView.Mcp) {
    return (
      <Notification kind="negative">
        Booking incomplete: The student you are attempting to refer has been in care with Mantra
        previously. Contact Mantra Care Navigation at{' '}
        <Text.externalLink
          href="mailto:hi@mantrahealth.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          hi@mantrahealth.com
        </Text.externalLink>{' '}
        to determine eligibility for care reactivation for this student
      </Notification>
    );
  }

  return (
    <Notification kind="negative">Referral not completed: Existing student account.</Notification>
  );
};
